import { colorModeOf, deriveAllCssVars } from './config';
// The community's colors and, over them, any worn on top (a tour's, or the Theme page's draft) on
// <html>. Every change recomputes the whole, so it doesn't matter which arrives first. Set as
// important because the server writes the community's colors into :root with !important.
let community = null;
const worn = [];
let written = [];
const apply = () => {
    const root = document.documentElement;
    const showing = community === null ? worn : [community, ...worn];
    const vars = Object.assign({}, ...showing.map(deriveAllCssVars));
    written.filter(name => !(name in vars)).forEach(name => root.style.removeProperty(name));
    Object.entries(vars).forEach(([name, value]) => root.style.setProperty(name, value, 'important'));
    written = Object.keys(vars);
    // Bootstrap's dark mode follows the background on top; light is its default, with no attribute.
    const top = showing[showing.length - 1];
    if (top !== undefined && colorModeOf(top) === 'dark')
        root.setAttribute('data-bs-theme', 'dark');
    else
        root.removeAttribute('data-bs-theme');
};
export const setCommunityTheme = (colors) => {
    community = colors;
    apply();
};
// Puts colors on over the community's, until the returned function takes them off.
export const wearTheme = (colors) => {
    worn.push(colors);
    apply();
    return () => {
        const index = worn.indexOf(colors);
        if (index === -1)
            return;
        worn.splice(index, 1);
        apply();
    };
};
